import * as React from 'react'


import { AboutUsComp, AboutUsContent, TextBody, TextContent, TextTitle } from './styles';
import { Formulario } from './formulario';

interface INavBar {
    
}

const Orcamento: React.FC<INavBar> = () => {

    return (
        <AboutUsComp id='orc'>
            <AboutUsContent>
                <TextContent>
                    <TextTitle>
                        <h1>Orçamento</h1>
                        <h2>Deixe seu dados e entraremos em contato!</h2>
                    </TextTitle>
                    <TextBody>
                        <Formulario />
                    </TextBody>
                </TextContent>
            </AboutUsContent>
        </AboutUsComp>
    );
}

export { Orcamento }